import React from "react";
import "../Css/ImpactStories.css";
import RealStories from "../Assets/RealStories.jpeg";
import Jennifer from "../Assets/Jennifer.jpeg";
import SivaAvula from "../Assets/ASPrasad.jpeg";
import Jim from "../Assets/Jim.jpeg";
import IlyaRozenblat from "../Assets/IlyaRozenblat.jpeg";
import WilbertRimper from "../Assets/WilbertRimper.jpeg";
import JohnDiPasquale from "../Assets/JohnDiPasquale.jpeg";
import Joe from "../Assets/Joe.jpeg";
import DeeD from "../Assets/DeeD.jpeg";
import Sushant from "../Assets/Sushant.jpeg";
import Nancy from "../Assets/Nancy.jpeg";
import AmyBerg from "../Assets/AmyBerg.jpeg";
import MayaChavez from "../Assets/MayaChavez.jpeg";

const ImpactStories = () => {
  return (
    <div className="is-wrapper">

      {/* Hero Image */}
      <div className="is-hero">
        <img
          src={RealStories}
          alt="Feature Stories — community table tennis moments"
          className="is-hero-img"
        />
        <div className="is-hero-overlay">
          <h1 className="is-hero-title">Real Stories. Real Impact.</h1>
        </div>
      </div>

      <div className="is-content">

        {/* Expert Opinions */}
        <div className="is-expert-section">
          <h2 className="is-section-heading">Expert Opinions</h2>

          <div className="is-expert-card">
            <div className="is-expert-profile">
              <img src={Jennifer} alt="Jennifer Gryniewicz" className="is-expert-photo" />
              <div className="is-expert-identity">
                <span className="is-expert-name">Jennifer Gryniewicz</span>
                <span className="is-expert-title">Parkinson's Disease Specialist</span>
                <a href="https://www.timeforyouwellness.net/" target="_blank" rel="noopener noreferrer" className="is-expert-org-link">
                  Owner of Time For You Wellness
                </a>
              </div>
            </div>
            <div className="is-expert-quote">
              <p className="is-expert-quote-text">
                "Ping Pong for Parkinson's delivers the essential elements necessary for improving
                overall quality of life for those living with PD and can be adapted to suit
                individuals at various stages of the disease. It provides the opportunity to
                reestablish damaged neurological pathways caused by the lack of dopamine resulting
                in improved strength, balance, coordination, and enhanced brain function. The social
                interaction and participation in Ping Pong also play an important role in boosting
                mood, confidence, and motivation"
              </p>
            </div>
          </div>

          <div className="is-expert-card">
            <div className="is-expert-profile">
              <img src={MayaChavez} alt="Maya Chavez" className="is-expert-photo" />
              <div className="is-expert-identity">
                <span className="is-expert-name">Maya Chavez</span>
                <span className="is-expert-title">Physical Therapist, Doctor of Physical Therapy, The Parkinson's Fitness Project</span>
              </div>
            </div>
            <div className="is-expert-quote">
              <p className="is-expert-quote-text">
                "Ping pong serves as a powerful tool for Parkinson's disease by combining rapid
                aerobic exercise with dual-tasking and visuospatial integration, which stimulates
                neuroplasticity. The sport uniquely combats motor symptoms such as bradykinesia and
                rigidity by challenging hand-eye coordination, fine and gross motor control,
                reaction times, and dynamic balance - which helps reduce fall risk and improve
                everyday functional activities like walking and upper-limb dexterity. Further,
                regular play in group or community settings fosters valuable social connection,
                improving overall emotional well-being"
              </p>
            </div>
          </div>

          <div className="is-expert-card">
            <div className="is-expert-profile">
              <img src={SivaAvula} alt="Dr. Siva Avula MD" className="is-expert-photo" />
              <div className="is-expert-identity">
                <span className="is-expert-name">Dr. Siva Avula MD</span>
                <span className="is-expert-title">Psychiatrist</span>
                <span className="is-expert-location">California</span>
              </div>
            </div>
            <div className="is-expert-quote">
              <p className="is-expert-quote-text">
                "Sports played a part in my life, helping me with routine, discipline, health and
                many more. Table tennis is a unique sport with respect to Parkinson's disease.
                Parkinson's disease is the loss of dopamine producing cells in substantia Nigra.
                Table tennis targets stimulating dopamine release which helps improve neurochemical
                depletion of dopamine through Neuroplasticity, mostly the visual motor responses in
                addition to fine precision imprinting in brain as well alternate brain pathways
                (visual and auditory clues), increase cortical efficiency. Table tennis helps in
                physical coordination, stimulating the brain, addressing symptoms of depression,
                anxiety, and improving social interaction in people with Parkinson's disease,
                mostly elderly. Table tennis would be a non-drug therapeutic treatment for
                Parkinson's pt's emotional wellbeing. Table tennis helps improve tremors; balance
                as well help improve rigidity which are core symptoms dealing in Parkinson's. Table
                tennis helps combat isolation, self confidence which help people with Parkinson's
                improve physical, cognitive, and emotional being overall improve the quality of
                life dealing with Parkinson's disease."
              </p>
            </div>
          </div>
        </div>

        {/* Participant Stories */}
        <div className="is-expert-section">
          <h2 className="is-section-heading">Participant Stories</h2>

          <div className="is-expert-card">
            <div className="is-expert-profile">
              <img src={Jim} alt="Jim" className="is-expert-photo" />
              <div className="is-expert-identity">
                <span className="is-expert-name">Jim</span>
                <span className="is-expert-title">Participant</span>
              </div>
            </div>
            <div className="is-expert-quote">
              <p className="is-expert-quote-text">
                "I consider table tennis to be a valuable asset in my arsenal of activities
                to enhance and preserve my hand-eye coordination, posture, and proprioception.
                It's also a lot of fun, especially with Sai's coaching to improve my game."
              </p>
            </div>
          </div>

          <div className="is-expert-card">
            <div className="is-expert-profile">
              <img src={Joe} alt="Joe" className="is-expert-photo" />
              <div className="is-expert-identity">
                <span className="is-expert-name">Joe</span>
                <span className="is-expert-title">Participant</span>
              </div>
            </div>
            <div className="is-expert-quote">
              <p className="is-expert-quote-text">
                "Joe was excited to play ping pong each Saturday, calling it the only exercise he
                wanted to do. After his passing, his wife shared how meaningful those sessions were
                and thanked the program for supporting PD patients."
              </p>
            </div>
          </div>

          <div className="is-expert-card">
            <div className="is-expert-profile">
              <img src={DeeD} alt="Dee D." className="is-expert-photo" />
              <div className="is-expert-identity">
                <span className="is-expert-name">Dee D.</span>
                <span className="is-expert-title">Participant</span>
              </div>
            </div>
            <div className="is-expert-quote">
              <p className="is-expert-quote-text">
                "I was diagnosed with PD in Nov 2023. Throughout my life, I've been physically
                active and have regularly attended exercise classes, practiced yoga, hiked,
                kayaked, skied, played tennis, walked with friends, etc. Having Parkinson's has
                brought with it many new challenges and I've been seeking out activities to keep
                me engaged while also helping me with my PD and the symptoms that accompany it.
                I've recently started attending the PingPong Parkinson bi-weekly events in
                Bellevue... And it is GREAT! Not only is it Super Fun, it's a Great Workout! Working
                with one of the awesome coaches there, I'm learning how to properly hold the
                paddle and to 'hit' many different kinds of shots! Spins, Forward, Backhand,
                Slamming the Ball, etc! Who knew there was a proper technique for each? I've
                enjoyed PingPong all my life, and played for many hours in my teen years on the
                ping pong table in my grandparents basement. So many fun and happy memories!
                Being able to play again with PingPong for Parkinson's has been a wonderful
                addition to my life."
              </p>
            </div>
          </div>

          <div className="is-expert-card">
            <div className="is-expert-profile">
              <img src={Sushant} alt="Sushant" className="is-expert-photo" />
              <div className="is-expert-identity">
                <span className="is-expert-name">Sushant</span>
                <span className="is-expert-title">Participant</span>
              </div>
            </div>
            <div className="is-expert-quote">
              <p className="is-expert-quote-text">
                "I read in the scientific press about how playing ping pong helps patients with
                Parkinson's. I used to be an avid player in school and college years. And found the
                connection quite fascinating. Have a friend in Melbourne Australia who was diagnosed
                with early onset Parkinson's a few years ago and I suggested that she try playing
                at the local PPP chapter. Her feedback was very positive and she has been playing
                for the last few months. Was fortunate to find a PPP chapter in Seattle and started
                volunteering to play with patients who come into the SPTTC every other Saturday.
                It is a really fun and well organized activity - an opportunity for me to connect
                with the community and thoroughly enjoyable."
              </p>
            </div>
          </div>

          <div className="is-expert-card">
            <div className="is-expert-profile">
              <img src={Nancy} alt="Nancy R." className="is-expert-photo" />
              <div className="is-expert-identity">
                <span className="is-expert-name">Nancy R.</span>
                <span className="is-expert-title">Participant</span>
              </div>
            </div>
            <div className="is-expert-quote">
              <p className="is-expert-quote-text">
                "Coming to this activity boosts my endorphins because it's physically active and
                so much fun. Also the connection to community has been a huge benefit. I'm very
                appreciative of you for organizing and making this happen for the Parkinson's
                community"
              </p>
            </div>
          </div>

          <div className="is-expert-card">
            <div className="is-expert-profile">
              <img src={AmyBerg} alt="Amy B." className="is-expert-photo" />
              <div className="is-expert-identity">
                <span className="is-expert-name">Amy B.</span>
                <span className="is-expert-title">Participant</span>
              </div>
            </div>
            <div className="is-expert-quote">
              <p className="is-expert-quote-text">
                "In my foursome we were actively moving to get the best angle on the ball, and
                several of us commented on how good it felt to move. Coming to this activity boosts
                my endorphins because it's physically active and so much fun. I enjoy the group and
                am thankful for these Saturday opportunities to play table tennis."
              </p>
            </div>
          </div>

        </div>

        {/* Community Testimonials */}
        <div className="is-expert-section">
          <h2 className="is-section-heading">Community Testimonials</h2>

          <div className="is-expert-card">
            <div className="is-expert-profile">
              <img src={IlyaRozenblat} alt="Ilya Rozenblat" className="is-expert-photo" />
              <div className="is-expert-identity">
                <span className="is-expert-name">Ilya Rozenblat</span>
                <span className="is-expert-title">Parkinson's Para-Athlete &amp; World Champion</span>
              </div>
            </div>
            <div className="is-expert-quote">
              <p className="is-expert-quote-text">
                "Table tennis helps reaction time, improves walking, and supports smoother, more confident movement."
              </p>
            </div>
          </div>

          <div className="is-expert-card">
            <div className="is-expert-profile">
              <img src={WilbertRimper} alt="Wilbert Rimper" className="is-expert-photo" />
              <div className="is-expert-identity">
                <span className="is-expert-name">Wilbert Rimper</span>
                <span className="is-expert-title">Parkinson's Para-Athlete</span>
              </div>
            </div>
            <div className="is-expert-quote">
              <p className="is-expert-quote-text">
                "We are family, special, and need support and encouragement with good intentions —
                and table tennis is like a natural vitamin you take to stay alive, enjoy life, help
                each other, and be thankful for. I treat every day like it's going to possibly be
                my last day on earth, so I try to enjoy the fullest life."
              </p>
            </div>
          </div>

          <div className="is-expert-card">
            <div className="is-expert-profile">
              <img src={JohnDiPasquale} alt="John DiPasquale" className="is-expert-photo" />
              <div className="is-expert-identity">
                <span className="is-expert-name">John DiPasquale</span>
                <span className="is-expert-title">Parkinson's Para-Athlete</span>
              </div>
            </div>
            <div className="is-expert-quote">
              <p className="is-expert-quote-text">
                "Table tennis boosts dopamine, improves my medication's effectiveness, and gives me joy."
              </p>
            </div>
          </div>

        </div>

      </div>

    </div>
  );
};

export default ImpactStories;